
export const environment = {
  production: true,

  //Define all url
  apiUrl: 'https://api.demo.app-services.link/api',
  baseUrl: 'https://api.demo.app-services.link',
  baseLoginUrl: 'https://api.demo.app-services.link/api',

  //Fet default category
  mainCategory: '0',
  lang: 'es',
  client: 'demo',
  logo: 'assets/demo/logo.png',
  appName: 'Demo App',
  menuPdf: false

};
